module.exports = __webpack_public_path__ + "img/Jugendgruppe.1c973dc5.svg";